import { render } from "./ListAllChoosenData.vue?vue&type=template&id=54e53b5c"
import script from "./ListAllChoosenData.vue?vue&type=script&lang=js"
export * from "./ListAllChoosenData.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__